import React, { useState } from "react";

import UniComplyLogo from "@icons/UniComply";
import { Send } from "@icons/Send";

import { Box, styled, Typography } from "@mui/material";
export const PageWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  backgroundColor: "#e6faff", // soft background around the box
  padding: "12px",
  boxSizing: "border-box",
});
export const HomePageContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#fdffff",
  height: "99vh",
  borderRadius: "12px",
  border: "1px solid #99d4e1",
  boxShadow: "inset 8px 2px 58.4px 0px rgba(191,242,255,0.2)",
  position: "relative",
  overflow: "hidden",
  width: "100%",
  alignItems: "center",
  boxSizing: "border-box",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    height: "auto",
    minHeight: "100vh",
    overflow: "visible",
  },
}));

export const MainContent = styled(Box)(({ theme }) => ({
  flex: 1,
  background: "#fdffff",
  //   borderRadius: "12px",
  //   border: "1px solid #99d4e1",
  boxShadow: "8px 2px 58.4px 0px inset rgba(191, 242, 255, 0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  minHeight: "100vh",
  "& .content-wrapper": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "32px",
    width: "100%",
    maxWidth: "800px",
    mt: "20px",
    justifyContent: "center", // center inside wrapper
  },

  "& .logo-section": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    "& svg": {
      width: 220,
      height: "auto",
    },
    [theme.breakpoints.down("md")]: {
      "& svg": {
        width: 180,
      },
    },
    [theme.breakpoints.down("sm")]: {
      "& svg": {
        width: 140,
      },
    },
  },

  "& .brand-text": {
    fontFamily: "'Rethink Sans', sans-serif",
    fontSize: "32px",
    fontWeight: "bold",
    lineHeight: "22px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
      lineHeight: "20px",
    },
  },

  "& .uni-text": {
    color: "#0a829d",
  },

  "& .comply-text": {
    color: theme.palette.text.primary,
  },

  "& .results-section": {
    width: "100%",
    maxWidth: "732px",
    background: theme.palette.background.paper,
    borderRadius: "12px",
    padding: "24px",
    border: "1px solid #99d4e1",

    "& h3": {
      color: theme.palette.primary.main,
      marginBottom: "16px",
      fontFamily: "'Rethink Sans', sans-serif",
      fontWeight: 600,
    },

    "& ul": {
      listStyle: "none",
      padding: 0,
      margin: 0,

      "& li": {
        padding: "12px 0",
        borderBottom: "1px solid #e5e5e5",
        color: theme.palette.text.primary,
        fontFamily: "'Rethink Sans', sans-serif",

        "&:last-child": {
          borderBottom: "none",
        },
      },
    },
  },
}));

export const SearchContainer = styled("form")(({ theme }) => ({
  width: "100%",
  maxWidth: "732px",
  background: "#fffefe",
  borderRadius: "12px",
  border: "1px solid #99d4e1",
  boxShadow: "3px -2px 4px 0px inset rgba(13, 147, 165, 0.25)",
  padding: "24px",
  [theme.breakpoints.down("sm")]: {
    padding: "16px",
    maxWidth: "80%",
    margin: "0 6px",
  },

  "& .search-wrapper": {
    display: "flex",
    alignItems: "stretch",
    gap: "8px",
    height: "96px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "auto",
    },
  },

  "& .search-input-container": {
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingLeft: "12px",
    height: "20px",
    // allow placeholder text to wrap on small screens
    "& input": {
      whiteSpace: "normal",
      overflowWrap: "break-word",
      wordBreak: "normal",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      height: "auto",
    },
  },
  "& .submit-btn": {
    alignSelf: "flex-end",
    [theme.breakpoints.down("sm")]: {
      alignSelf: "stretch",
    },
  },
}));

export const SearchInput = styled("input")(({ theme }) => ({
  flex: 1,
  border: "none",
  outline: "none",
  background: "transparent",
  fontFamily: "'Rethink Sans', sans-serif",
  fontSize: "16px",
  fontWeight: 400,
  color: theme.palette.text.primary,
  letterSpacing: "-0.4px",
  lineHeight: 1.5,
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },

  "&::placeholder": {
    color: "#a1a1aa",
  },

  "&:focus": {
    outline: "none",
  },
}));

export const SubmitButton = styled("button")(({ theme }) => ({
  background: "#0a829d",
  border: "none",
  borderRadius: "8px",
  padding: "16px 20px",
  display: "flex",
  alignItems: "end",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0px 4px 8.3px 0px rgba(98, 98, 98, 0.4)",
  transition: "all 0.2s ease",
  alignSelf: "flex-end",
  "&:hover": {
    background: "#065b70",
    transform: "translateY(-1px)",
    boxShadow: "0px 6px 12px 0px rgba(98, 98, 98, 0.5)",
  },

  "&:active": {
    transform: "translateY(0)",
    boxShadow: "0px 2px 4px 0px rgba(98, 98, 98, 0.3)",
  },

  "& svg": {
    color: "white",
    width: "24px",
    height: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "12px 14px",
    "& svg": {
      width: "18px",
      height: "18px",
    },
  },
}));
export default function LandingPage() {
  // const Home: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const [showComingSoon, setShowComingSoon] = useState(false);

  const handleButtonClick = () => {
    if (searchQuery.trim()) {
      setShowComingSoon(true);

      // ⏱ Hide after 30 seconds
      setTimeout(() => {
        setShowComingSoon(false);
      }, 2000);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <HomePageContainer>
      <MainContent>
        <div className="content-wrapper">
          <div className="logo-section">
            <UniComplyLogo />
            {/* <UniComplyLogo size={158} /> */}
            <div className="brand-text">
              <span className="uni-text">Uni</span>
              <span className="comply-text">Comply.ai</span>
            </div>
          </div>

          <SearchContainer>
            <div className="search-wrapper">
              <div className="search-input-container">
                <SearchInput
                  type="text"
                  placeholder="Ask about Compliance requirements..."
                  value={searchQuery}
                  onChange={handleInputChange}
                />
              </div>
              <SubmitButton type="button" onClick={handleButtonClick}>
                <Send />
              </SubmitButton>
            </div>
          </SearchContainer>
          {showComingSoon && (
            <Box
              sx={{
                backgroundColor: "#fffdfd",
                border: "1px solid #ccf5ff",
                borderRadius: "12px",
                boxShadow: "0px 4px 16px 0px rgba(5,89,108,0.08)",
                padding: "16px",
                width: { xs: "75%", sm: "70%", md: "90%" },
                display: "flex",
                flexDirection: "column",
              }}
            >
              {" "}
              <Typography sx={{ fontSize: "24px", fontWeight: 500 }}>
                {" "}
                Coming Soon...
              </Typography>
            </Box>
          )}
        </div>
      </MainContent>
    </HomePageContainer>
  );
}

// export { Home };
